<template>
  <div
    :is="component.name"
    v-if="metaView && component"
    ref="metaBlock"
    :meta-view="metaView"
    :read-settings-styles="readSettingsStyles"
    :wrapping-read-settings-styles="wrappingReadSettingsStyles"
    :description-styles="descriptionStyles"
    :is-content-ready="isContentReady"
    @hook:mounted="onComponentMounted"
    @metablockEvent="metablockEventHandler"
  />
</template>

<script>
import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('MetaBlock.vue');

import MetablockEventEnum from '@/enums/MetablockEventEnum';
import PublicationsTypesEnum from '@shared/enums/PublicationsTypesEnum';
import CustomErrorEnum from '@/enums/CustomErrorEnum';

import BookMetaBlock from '@/components/views/MetaBlock/BookMetaBlock/BookMetaBlock';
import CompilationMetaBlock from '@/components/views/MetaBlock/CompilationMetaBlock/CompilationMetaBlock';

import PublicationErrorHandlingLogicService from '@/services/PublicationLogic/PublicationErrorHandlingLogicService';

export default {
  name: 'MetaBlock',
  components: {
    BookMetaBlock,
    CompilationMetaBlock
  },
  data() {
    return {};
  },
  computed: {
    publicationId() {
      return this.$store.getters['OpenParameterStore/getPublicationId'];
    },
    metaView() {
      const metaView = this.$store.getters['PublicationStore/getMetaView'](
        this.publicationId
      );
      return metaView;
    },
    component() {
      let component = '';
      if (!this.metaView) {
        return component;
      }
      switch (this.metaView.type) {
        case PublicationsTypesEnum.BOOK:
          component = BookMetaBlock;
          break;
        case PublicationsTypesEnum.COMPILATION:
          component = CompilationMetaBlock;
          break;
        default: {
          const message = `Get unsuported publication type for show metablock type:${this.metaView.type}  publicationId:${this.publicationId}`;
          logger.error(message);
          this.$_metaBlockErrorHandler({
            name: CustomErrorEnum.UNSUPPORTED_TYPE,
            message
          });
          break;
        }
      }
      return component;
    },
    wrappingReadSettingsStyles() {
      return this.$store.getters[
        'ReadingSettingsStore/getWrappingReadingSettingsStyles'
      ];
    },
    readSettingsStyles() {
      return this.$store.getters[
        'ReadingSettingsStore/getReadingSettingsStyles'
      ];
    },
    descriptionStyles() {
      const fontFamily = this.wrappingReadSettingsStyles[1];
      return { ...fontFamily };
    },
    isContentReady() {
      return this.$store.getters['PublicationStore/isAudioReady']();
    }
  },
  watch: {
    async publicationId(newId) {
      if (newId) {
        await this.$_reInitMeta(newId);
      }
    }
  },
  async mounted() {
    if (this.publicationId) {
      await this.$_reInitMeta(this.publicationId);
    }
  },
  methods: {
    onComponentMounted() {
      const element = this.$refs?.metaBlock?.$el || null;
      if (!element) {
        logger.error(`Did not find metablock element for calculate height`);
        return;
      }
      const marginStr = window.getComputedStyle(element).marginBottom;
      const margin = parseInt(marginStr.replace('px', ''));
      const height = element.clientHeight + margin;

      const metaBlockHeigth = isNaN(height) ? 0 : height;
      this.$store.commit(
        'PublicationStore/setMetaBlockHeigth',
        metaBlockHeigth
      );
    },
    metablockEventHandler(payload) {
      const { type, data } = payload;
      this.$_emitEvent(type, data);
    },
    async $_reInitMeta(publicationId) {
      try {
        await this.$store.dispatch('PublicationStore/fillMeta', {
          publicationId
        });
      } catch (error) {
        logger.error(`Get error on read meta error: ${error}`);
        PublicationErrorHandlingLogicService.openBookErrorHandling(
          this.$store,
          this.$t.bind(this),
          error
        );
      }
    },
    $_metaBlockErrorHandler(error) {
      this.$_emitEvent(MetablockEventEnum.ERROR, { error });
    },
    $_emitEvent(type, data = {}) {
      this.$emit('metablockEvent', {
        type,
        data
      });
    }
  }
};
</script>

<style lang="less" src="./MetaBlock.less"></style>
